export const LICENCE = Object.freeze({
  free: { name: 'free', description: 'Neplacená licence' },
  pay: { name: 'pay', description: 'Placená licence' },
});
